import * as React from "react";
import { SVGProps } from "react";
const SvgValueProposition = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 3c2.079 0 4.066.477 5.906 1.416a1.001 1.001 0 0 1-.91 1.781A10.887 10.887 0 0 0 16 5C9.935 5 5 9.935 5 16s4.935 11 11 11 11-4.935 11-11c0-1.614-.341-3.169-1.015-4.622a1 1 0 1 1 1.815-.841A12.907 12.907 0 0 1 29 16c0 7.168-5.832 13-13 13S3 23.168 3 16 8.832 3 16 3Zm9.772 2.993a1 1 0 0 1 .235 1.394L16.552 20.68a.999.999 0 0 1-1.395.235l-4.905-3.488a1 1 0 0 1 1.159-1.63l4.09 2.908 8.877-12.477a.998.998 0 0 1 1.394-.235Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgValueProposition;
